import { render } from "./socialMediaIcon.vue?vue&type=template&id=06869c18"
import script from "./socialMediaIcon.vue?vue&type=script&lang=js"
export * from "./socialMediaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__